site.ada.config = site.ada.config || {};

site.ada.config.instafeed = { subtree: false, childList: true };
site.ada.instaWrapper = document.querySelector("div[data-crl8-container-id='homepage'], div[crl8-container-id='product']");

const instafeedNode = (el)=>{
  if(['crl8-homepage-carousel', 'crl8-product-carousel'].includes(el.getAttribute('id'))) {
    return true;
  } 
};

const instafeedCallback = ()=>{document.dispatchEvent(new CustomEvent('instafeed:loaded'));};
/**
 * Function that handles all the ADA updates to the Instagram Feed section.
 * When adding a new element to change, add the initializer in the init
 *  and the function to do the changes.
 */
site.ada.instafeedAdaUpdates = function() {
 this.setElementAttribute = function() {
    const slideRole = function(elements) {
      Array.from(elements).forEach(element => {
        element.removeAttribute('role');
      });
    }

    site.ada.elementTimer("[class*='homepage-carousel-item'] [aria-label^='Slide']", slideRole);
    site.ada.elementTimer("[class*='product-carousel-item'] [aria-label^='Slide']", slideRole);
  }

  this.setTextRole = function() {
    site.ada.elementTimer('.sc-102xyuw-3', function(elements) { 
      Array.from(elements).forEach(element => {
        element.removeAttribute('role');
        element.removeAttribute('aria-level');
      });
    });
  }

  this.removeMislabeledAriaElements = function() {
    site.ada.elementTimer('#crl8-homepage-carousel-carousel-heading', function(elements) { 
      Array.from(elements).forEach(element => {
        element.removeAttribute('aria-level');
        element.removeAttribute('role');
      });
    });
  }

  this.init = function () {
    this.setElementAttribute();
    this.setTextRole();
    this.removeMislabeledAriaElements();
  }

  this.init();
};

// Event listener when the Instagram Feed wrapper loads.
document.addEventListener('instafeed:loaded', site.ada.instafeedAdaUpdates);

/*
 * MutationObserver that detects when Instagram Feed section is loaded into the DOM.
 * Note: This only covers the initial wrapper.
 *    The contents of Instagram Feed load in a second time, which is why the setTimout is present.
 */

if (site.ada.observer){site.ada.observer(instafeedNode, instafeedCallback, site.ada.instaWrapper, site.ada.config.instafeed);}
